/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalFilterExclusionInput } from './GlobalFilterExclusionInput';
import {
    GlobalFilterExclusionInputFromJSON,
    GlobalFilterExclusionInputFromJSONTyped,
    GlobalFilterExclusionInputToJSON,
    GlobalFilterExclusionInputToJSONTyped,
} from './GlobalFilterExclusionInput';
import type { RoundRobinType } from './RoundRobinType';
import {
    RoundRobinTypeFromJSON,
    RoundRobinTypeFromJSONTyped,
    RoundRobinTypeToJSON,
    RoundRobinTypeToJSONTyped,
} from './RoundRobinType';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { CreateLeagueBodyPointsConfig } from './CreateLeagueBodyPointsConfig';
import {
    CreateLeagueBodyPointsConfigFromJSON,
    CreateLeagueBodyPointsConfigFromJSONTyped,
    CreateLeagueBodyPointsConfigToJSON,
    CreateLeagueBodyPointsConfigToJSONTyped,
} from './CreateLeagueBodyPointsConfig';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';
import type { TiebreakerMethod } from './TiebreakerMethod';
import {
    TiebreakerMethodFromJSON,
    TiebreakerMethodFromJSONTyped,
    TiebreakerMethodToJSON,
    TiebreakerMethodToJSONTyped,
} from './TiebreakerMethod';

/**
 * 
 * @export
 * @interface CreateLeagueBody
 */
export interface CreateLeagueBody {
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    matchModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    sponsorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeagueBody
     */
    seasonName?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    seasonNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    seasonStartDate?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    seasonEndDate?: number;
    /**
     * 
     * @type {RoundRobinType}
     * @memberof CreateLeagueBody
     */
    roundRobinType?: RoundRobinType;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof CreateLeagueBody
     */
    scoringMode?: MatchScoringMode;
    /**
     * 
     * @type {MatchFormat}
     * @memberof CreateLeagueBody
     */
    matchFormat?: MatchFormat;
    /**
     * 
     * @type {CreateLeagueBodyPointsConfig}
     * @memberof CreateLeagueBody
     */
    pointsConfig?: CreateLeagueBodyPointsConfig;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    teamSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    minTeams?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeagueBody
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBody
     */
    registrationDeadline?: number;
    /**
     * Methods used to break ties in standings (in order of priority)
     * @type {Array<TiebreakerMethod>}
     * @memberof CreateLeagueBody
     */
    tiebreakerMethods?: Array<TiebreakerMethod>;
    /**
     * ScoringTemplate ID for EVENT_PIPELINE scoring
     * @type {string}
     * @memberof CreateLeagueBody
     */
    scoringTemplateId?: string;
    /**
     * Cheat-filtering match-bracketing gate — drops scoring events fired outside Match Start / Round Start. Mirror of the field on update_league.ts; without this on CREATE, the admin UI checkbox is silently discarded and the model default (`false`) is persisted (CLAUDE.md "Save Doesn't Stick" pattern).
     * @type {boolean}
     * @memberof CreateLeagueBody
     */
    requireActiveMatch?: boolean;
    /**
     * Inclusion-framework WU 1.10.7 — IDs of EventPipelineFilter documents to apply to this league's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof CreateLeagueBody
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass exclusions of GLOBAL filters for this league (PRODUCT_PLAN D2(b)). excludedBy and excludedAt are stamped server-side and ignored if sent.
     * @type {Array<GlobalFilterExclusionInput>}
     * @memberof CreateLeagueBody
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusionInput>;
    /**
     * Rule 4 opt-out. When true this league still scores events whose match context is missing. Default false — a league that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof CreateLeagueBody
     */
    failOpenOnMissingContext?: boolean;
}



/**
 * Check if a given object implements the CreateLeagueBody interface.
 */
export function instanceOfCreateLeagueBody(value: object): value is CreateLeagueBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateLeagueBodyFromJSON(json: any): CreateLeagueBody {
    return CreateLeagueBodyFromJSONTyped(json, false);
}

export function CreateLeagueBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeagueBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'seasonName': json['seasonName'] == null ? undefined : json['seasonName'],
        'seasonNumber': json['seasonNumber'] == null ? undefined : json['seasonNumber'],
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : json['seasonStartDate'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'roundRobinType': json['roundRobinType'] == null ? undefined : RoundRobinTypeFromJSON(json['roundRobinType']),
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'matchFormat': json['matchFormat'] == null ? undefined : MatchFormatFromJSON(json['matchFormat']),
        'pointsConfig': json['pointsConfig'] == null ? undefined : CreateLeagueBodyPointsConfigFromJSON(json['pointsConfig']),
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'registrationDeadline': json['registrationDeadline'] == null ? undefined : json['registrationDeadline'],
        'tiebreakerMethods': json['tiebreakerMethods'] == null ? undefined : ((json['tiebreakerMethods'] as Array<any>).map(TiebreakerMethodFromJSON)),
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
    };
}

export function CreateLeagueBodyToJSON(json: any): CreateLeagueBody {
    return CreateLeagueBodyToJSONTyped(json, false);
}

export function CreateLeagueBodyToJSONTyped(value?: CreateLeagueBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'matchModeId': value['matchModeId'],
        'ruleSetId': value['ruleSetId'],
        'sponsorId': value['sponsorId'],
        'seasonName': value['seasonName'],
        'seasonNumber': value['seasonNumber'],
        'seasonStartDate': value['seasonStartDate'],
        'seasonEndDate': value['seasonEndDate'],
        'roundRobinType': RoundRobinTypeToJSON(value['roundRobinType']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'matchFormat': MatchFormatToJSON(value['matchFormat']),
        'pointsConfig': CreateLeagueBodyPointsConfigToJSON(value['pointsConfig']),
        'teamSize': value['teamSize'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'requiresApproval': value['requiresApproval'],
        'registrationDeadline': value['registrationDeadline'],
        'tiebreakerMethods': value['tiebreakerMethods'] == null ? undefined : ((value['tiebreakerMethods'] as Array<any>).map(TiebreakerMethodToJSON)),
        'scoringTemplateId': value['scoringTemplateId'],
        'requireActiveMatch': value['requireActiveMatch'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
    };
}

